import { Pagination, PaginationItem } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowNext from "../../../assets/svgs/arrow-next.svg";

interface PaginationProps {
  pages?: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}
const ArrowBackIcon = () => (
  <img
    src={ArrowNext}
    alt="Página anterior"
    style={{ transform: "rotate(180deg)" }}
  />
);

const ArrowNextIcon = () => <img src={ArrowNext} alt="Próxima página" />;

const PaginationGrid = (props: PaginationProps) => {
  const { pages, currentPage, setCurrentPage } = props;

  const [totalPages, setTotalPages] = useState(pages ?? 1);

  useEffect(() => {
    setTotalPages(pages === undefined || pages === 0 ? 1 : pages);
  }, [pages]);

  useEffect(() => {
    if (pages !== undefined && currentPage > pages) {
      setCurrentPage(1);
    }
  }, [pages, currentPage, setCurrentPage]);

  const handleChangePage = (_event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  return (
    <Pagination
      count={totalPages}
      siblingCount={3}
      onChange={handleChangePage}
      color="primary"
      page={currentPage}
      renderItem={(item) => (
        <PaginationItem
          slots={{ previous: ArrowBackIcon, next: ArrowNextIcon }}
          {...item}
        />
      )}
      sx={{
        marginTop: "10px",
      }}
    />
  );
};

export default PaginationGrid;
